<template>
  <div id="scroll-target">
    <vs-row class="my-2" style="min-height: 120px">
      <vs-col vs-lg="8" vs-md="12" vs-sm="12">
        <SummaryTable :stats="stats"></SummaryTable>
      </vs-col>
      <vs-col vs-lg="4" vs-md="12" vs-sm="12">
        <div style="float: right">
          <b-form-input
            id="search"
            class="inputx"
            style="text-transformation: none; width: 300px"
            placeholder="Search..."
            v-bind:value="search"
            v-on:input="debounceInput"
            @keydown.esc="clearSearch()"
          />
          <i
            id="search-cancel"
            class="fas fa-times fa-2x cursor-pointer text-primary"
            @mousedown="clearSearch()"
          >
          </i>
        </div>
      </vs-col>
    </vs-row>
    <div class="text-left visible lg:hidden mt-2">
      <!-- action table -->
      <ul class="demo-alignment pb-0" style>
        <li>
          <vs-checkbox
            v-model="ord_type"
            color="grey"
            vs-value="buy"
            @change="refreshTable()"
            >Buy</vs-checkbox
          >
        </li>
        <li>
          <vs-checkbox
            v-model="ord_type"
            color="grey"
            vs-value="free"
            @change="refreshTable()"
            >Free</vs-checkbox
          >
        </li>
        <li>
          <vs-checkbox
            v-model="ord_type"
            color="grey"
            vs-value="upg"
            @change="refreshTable()"
            >Upgrade</vs-checkbox
          >
        </li>
      </ul>
      <!-- <div class="mt-5 text-left">
        <vs-button
          class="mr-2"
          color="grey"
          type="border"
          @click="refreshTable()"
        >Apply</vs-button>
        <vs-button color="grey" type="border" @click="onExport()">
          <i class="fas fa-file-download"></i>
        </vs-button>
      </div>-->
    </div>
    <vs-row>
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0">
        <div class="ml-lg-4" style="max-width: 100%; overflow-x: auto">
          <h2 class="mb-1">{{ routeTitle }}</h2>
          <vs-tabs
            class="mb-0"
            v-model="viewIndex"
            style="width: auto; float: left"
          >
            <vs-tab label="Recent" @click="setView('', true)">
              <div></div>
            </vs-tab>
            <vs-tab
              v-if="isSuperAdmin"
              label="Need Action"
              @click="setView('needaction', true)"
            >
              <div></div>
            </vs-tab>
            <vs-tab
              v-else
              label="Processing"
              @click="setView('needaction', true)"
            >
              <div></div>
            </vs-tab>
            <vs-tab label="Pending" @click="setView('pending', true)">
              <div></div>
            </vs-tab>
            <vs-tab label="Expired" @click="setView('expired', true)">
              <div></div>
            </vs-tab>
            <vs-tab label="Waited List" @click="setView('waitedlist', true)">
              <div></div>
            </vs-tab>
            <vs-tab :label="lastTabText" @click="setView('void', true)">
              <div></div>
            </vs-tab>
          </vs-tabs>
          <vs-dropdown>
            <vs-button
              class="btn-drop"
              color="gray"
              type="flat"
              style="padding: 0rem 1rem 0.75rem"
            >
              <span style="font-size: 1.1rem"></span>&nbsp;
              <i class="fas fa-chevron-down"></i>
            </vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setView('confirmed', true)"
                >Confirmed</vs-dropdown-item
              >
              <vs-dropdown-item @click="setView('duplicate', true)"
                >Duplicate</vs-dropdown-item
              >
              <vs-dropdown-item
                @click="setView('trash', true)"
                v-if="isSuperAdmin"
                >Trash</vs-dropdown-item
              >
              <vs-dropdown-item @click="setView('all', true)"
                >View All</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <!-- action table -->
          <ul class="demo-alignment pb-0" style="float: right">
            <li>
              <vs-checkbox
                v-model="ord_type"
                color="primary"
                vs-value="buy"
                @change="refreshTable()"
                >Buy</vs-checkbox
              >
            </li>
            <li>
              <vs-checkbox
                v-model="ord_type"
                color="primary"
                vs-value="upg"
                @change="refreshTable()"
                >Upgrade</vs-checkbox
              >
            </li>
            <li>
              <vs-checkbox
                v-model="ord_type"
                color="primary"
                vs-value="free"
                @change="refreshTable()"
                >Free</vs-checkbox
              >
            </li>
            <!-- <li>
              <vs-button color="primary" type="border" @click="refreshTable()">Apply</vs-button>
            </li>-->
            <li
              v-if="showExport"
              class="pl-4 border-0 border-l border-solid border-grey"
            >
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport2()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template #empty="scope">
          <div class="text-center">
            <h4><strong>There's nothing here yet.</strong></h4>
          </div>
        </template>
        <!--
        <template v-slot:head(order_id)="data">
          <span class="text-info">{{ data.label.toUpperCase() }}</span>
        </template>-->

        <template v-slot:cell(rowstatus)="data">
          <div>
            <vs-chip
              style="width: 135px"
              v-bind:class="data.value.toLowerCase().replace(' ', '')"
              >{{ data.value.toUpperCase() }}</vs-chip
            >
          </div>
        </template>

        <template v-slot:cell(unique_id)="data">
          <div style="width: 70px">{{ data.value }}</div>
        </template>

        <template v-slot:cell(name)="data">
          <div style="width: 150px">
            {{ data.value.first }} {{ data.value.last }}
          </div>
        </template>

        <template v-slot:cell(email)="data">
          <span @click="onEmailClicked(data.item.email)">{{
            data.item.email
          }}</span>
        </template>

        <template v-slot:cell(amount)="data">
          <div>{{ data.value | numFormat("0,0.00") }}</div>
          <div v-if="data.item.discount">
            <small class="text-muted">{{ data.item.pc }}</small>
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
            {{ data.item.discount | numFormat("0,0.00") }}
          </div>
          <div v-if="data.item.wht == 'y'">
            <small class="text-muted"
              >WHT
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
              {{ data.item.wht_amount | numFormat("0,0.00") }}
            </small>
          </div>
        </template>

        <template v-slot:cell(quantity)="data">
          <b-button @click="openTicket(data.item)" variant="outline-secondary">
            {{ data.value }}
          </b-button>
        </template>

        <template v-slot:cell(upload)="data">
          <i
            v-if="data.value != 'n'"
            class="far fa-file-image fa-2x"
            @click="showSlip(data)"
          ></i>
          <span v-else>N</span>
        </template>

        <template v-slot:cell(approve)="data">
          <i v-if="data.value == 'y'" class="fas fa-check fa-2x"></i>
          <span v-if="data.value == 'n'">N</span>
        </template>

        <template v-slot:cell(paidby)="data">
          <div>
            <i
              v-if="data.value == 'creditcard'"
              class="far fa-credit-card fa-2x"
            ></i>
            <i
              v-if="data.value == 'transfer'"
              class="fas fa-exchange-alt fa-2x"
            ></i>
          </div>
        </template>

        <template v-slot:cell(errors)="data">
          <template v-if="data.item.errordate != null">
            <div
              v-for="(error, index) in data.value"
              :key="index"
              style="color: #a94442; width: 140px"
              @click="onOpenCreditCardDialog(data)"
              class="mb-2"
            >
              <div v-if="error.res_msg">
                {{ index + 1 }}. {{ error.so_timestamp }} {{ error.res_msg }}
              </div>
              <div v-if="error.failReason">
                {{ index + 1 }}. {{ error.so_timestamp }} {{ error.failReason }}
              </div>
            </div>
          </template>
        </template>

        <template v-slot:cell(actions)="data">
          <div v-if="filterActions(data.value).length > 0" class="d-flex">
            <b-button-group>
              <b-button
                size="sm"
                :variant="'outline-secondary'"
                @click="onAction(data.item, filterActions(data.value)[0])"
                :style="
                  `${filterActions(data.value).length > 1 ? 'width: 120px;' : 'width: 160px;'}`
                "
              >
                <div class="d-flex align-items-center">
                  <i :class="filterActions(data.value)[0].icon" class="cursor-pointer"></i>
                  <div class="ml-2">{{ filterActions(data.value)[0].text }}</div>
                </div>
              </b-button>
              <b-dropdown
                v-if="filterActions(data.value).length > 1"
                size="sm"
                variant="outline-secondary"
                style=""
              >
                <b-dropdown-item
                  v-for="(item, index) in filterActions(data.value).slice(1)"
                  :key="index"
                  @click="onAction(data.item, item)"
                >
                  <i :class="item.icon" class="cursor-pointer"></i>
                  {{ item.text }}
                </b-dropdown-item>
              </b-dropdown>
            </b-button-group>
          </div>
        </template>

        <template v-slot:cell(progress)="data">
          <div
            v-if="
              parseFloat(data.item.amount) != 0 && event && event.fields_status
            "
          >
            <vs-progress
              :height="12"
              :percent="
                data.item.confirm_date // && data.item.is_answer_attendee_info
                  ? 100 // : data.item.confirm_date // ? 50
                  : data.item.register_date
                  ? 10
                  : 0
              "
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px">
                Register
              </div>
              <div style="width:82px" class="text-right">
                Pay
              </div>
              <!-- <div style="width:82px" class="text-right">
                Attendee Info
              </div> -->
            </div>
          </div>
          <div v-else-if="event && event.fields_status">
            <vs-progress
              :height="12"
              :percent="
                // data.item.is_answer_attendee_info
                //   ? 100
                //   :
                data.item.register_date ? 100 : 0
              "
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px" class="ml-auto text-right">
                Register
              </div>
              <!-- <div style="width:82px" class="text-right">
                Attendee Info
              </div> -->
            </div>
          </div>
          <div v-else-if="parseFloat(data.item.amount) != 0">
            <vs-progress
              :height="12"
              :percent="
                data.item.confirm_date ? 100 : data.item.register_date ? 10 : 0
              "
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px">
                Register
              </div>
              <div style="width:82px" class="text-right">
                Pay
              </div>
            </div>
          </div>
          <div v-else>
            <vs-progress
              :height="12"
              :percent="data.item.register_date ? 100 : 0"
              color="primary"
            ></vs-progress>
            <div class="d-flex justify-content-between" style="width:300px">
              <div style="width:82px"></div>
              <div style="width:82px" class="text-right">
                Register
              </div>
            </div>
          </div>
        </template>
        <template v-slot:cell(promotion)="data">
          <div>
            {{ data.item.promotitle }}
            <span v-if="data.item.promo_type == 'code'"
              >({{ data.item.pccode }})</span
            >
            <span v-else-if="data.item.promo_type == 'link'"
              >({{ data.item.token }})</span
            >
          </div>
          <div>
            <small class="text-muted">{{ data.item.promonote }}</small>
          </div>
        </template>
        <template v-slot:cell(remark)="data">
          <div style="position: relative">
            <div
              class="cursor-pointer"
              @click="openEditRemark(data.item)"
              style="
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
              "
            ></div>
            <b-form-input
              style="width: 300px"
              :disabled="true"
              placeholder="Add Remark"
              v-model="data.value"
            />
          </div>
        </template>
        <template v-slot:cell(orderdata)="data">
          <b-button
            style="width: 80px;"
            @click="showProductList(data.item)"
            variant="outline-secondary"
          >
            View
          </b-button>
        </template>
      </b-table>

      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          :max="7"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">
          {{ from | numFormat("0,0") }} to {{ to | numFormat("0,0") }} of
          {{ totalRows | numFormat("0,0") }} orders
        </div>
      </div>
      <!-- LOG -->
      <!--
      <section class="mt-5">
        <h3>Log Query</h3>
        <div class="mt-3">
          <vs-row vs-w="12">
            <vs-col vs-justify="center" vs-align="center" vs-w="6">
              <div class="my-3" :key="index" v-for="(item,index) in log">{{item.query}}</div>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-w="6"></vs-col>
          </vs-row>
        </div>
      </section>
      -->
    </vs-card>

    <ProductListModal
      :show="productListDialog"
      :order-data="selectedProductData"
      :order-info="selectedOrder"
      :role="role"
      @close="productListDialog = false"
    />

    <!-- START REMARK POPUP -->
    <vs-popup
      classContent="popup-example"
      title="Edit order remark"
      :active.sync="remarkDialog"
    >
      <template v-if="selectedOrder != null">
        <div>
          <vs-textarea v-model="selectedOrder.remark" />
        </div>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
              style="width: 100%"
              color="primary"
              type="filled"
              @click="
                onUpdateRemark(selectedOrder.order_id, selectedOrder.remark)
              "
              >Save</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
              style="width: 100%"
              color="primary"
              type="flat"
              @click="remarkDialog = false"
              >Close</vs-button
            >
          </vs-col>
        </vs-row>
      </template>
    </vs-popup>

    <!-- START EXTEND POPUP -->
    <vs-popup
      classContent="popup-example"
      title="Extend Payment Deadline"
      :active.sync="extendDialog"
    >
      <template v-if="selectedOrder != null">
        <div class="text-xs-center mb-3">
          <div>Extend Payment for (days)</div>
          <vs-input-number v-model="selectedOrder.days" />
        </div>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
              style="width: 100%"
              color="primary"
              type="flat"
              @click="extendDialog = false"
              >Cancel</vs-button
            >
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
              style="width: 100%"
              color="primary"
              type="filled"
              @click="
                onUpdate(selectedOrder.order_id, 'extend-deadline', {
                  days: selectedOrder.days
                })
              "
              >Save</vs-button
            >
          </vs-col>
        </vs-row>
      </template>
    </vs-popup>

    <!-- START RESEND POPUP -->
    <vs-popup
      classContent="popup-example"
      title="Resend Messages"
      :active.sync="resendDialog"
    >
      <template v-if="selectedOrder != null">
        <div class="text-xs-center mb-3">
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
            ></vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              >Email</vs-col
            >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              >SMS</vs-col
            >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              >Both</vs-col
            >
          </vs-row>
          <vs-divider />
          <vs-row class="mt-2">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
              >Send Pay Link</vs-col
            >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
            >
              <vs-button color="primary" type="border">
                <i class="far fa-paper-plane"></i>
              </vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
            >
              <vs-button color="primary" type="border">
                <i class="far fa-paper-plane"></i>
              </vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
            >
              <vs-button color="primary" type="border">
                <i class="far fa-paper-plane"></i>
              </vs-button>
            </vs-col>
          </vs-row>
          <vs-divider />
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-button
              style="width: 100%"
              color="primary"
              type="flat"
              @click="resendDialog = false"
              >Close</vs-button
            >
          </vs-col>
        </vs-row>
      </template>
    </vs-popup>

    <!-- START PAYMENT SLIP POPUP -->
    <vs-popup
      classContent="popup-example"
      title="Paymant Slip"
      :active.sync="slipDialog"
    >
      <div class="text-center mb-3">
        <img :src="selectedMedia.url" style="width: 100%" />
        <div>{{ selectedMedia.caption }}</div>
      </div>
    </vs-popup>

    <!-- START ERROR DETAIL POPUP -->
    <vs-popup
      classContent="popup-example"
      title="Error Detail"
      :active.sync="creditCardDialog"
    >
      <div class="mb-3">
        <div v-for="(error, index) in selectedError" :key="index">
          <h3>
            {{ error.so_timestamp }} - {{ error.failReason }} ({{
              error.respCode
            }})
          </h3>
          <div v-for="(list, key) in error" :key="key">
            {{ key }} : {{ list }}
          </div>
          <vs-divider />
        </div>
      </div>
    </vs-popup>

    <approve-modal
      :order="selectedOrder"
      @close="onApproveDialogClose"
    ></approve-modal>

    <order-received-modal
      :order="selectedOrder"
      @close="onOrderReceivedDialogClose"
    ></order-received-modal>

    <packed-modal
      :order="selectedOrder"
      @close="onPackedDialogClose"
    ></packed-modal>

    <shipped-modal
      :order="selectedOrder"
      @close="onShippedDialogClose"
    ></shipped-modal>
    <delivered-modal
      :order="selectedOrder"
      @close="onDeliveredDialogClose"
    ></delivered-modal>
  </div>
</template>
<script>
//import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import SummaryTable from "@/components/soldoutt/SummaryTable.vue";

import { mapState } from "vuex";

import moment from "moment";
import XLSX from "xlsx"; // import xlsx
import Service from "@/services";

import ApproveModal from "@/components/soldoutt/ApproveModal.vue";
import OrderReceivedModal from "@/components/soldoutt/OrderReceivedModal.vue";
import PackedModal from "@/components/soldoutt/PackedModal.vue";
import ShippedModal from "@/components/soldoutt/ShippedModal.vue";
import DeliveredModal from "@/components/soldoutt/DeliveredModal.vue";
import ProductListModal from "@/components/soldoutt/ProductListModal.vue";

import {
  adminOrderCols,
  customerOrderCols,
  pttgcOrderCols,
  standardOrderCols,
  freeOrderCols,
  exportFreeOrderCols,
  exportStandardOrderCols
} from "@/utils/columns";

export default {
  name: "Orders",
  components: {
    ApproveModal,
    OrderReceivedModal,
    PackedModal,
    ShippedModal,
    DeliveredModal,
    SummaryTable,
    ProductListModal
  },
  data: () => ({
    role: "",
    isBusy: false,
    remarkDialog: false,
    extendDialog: false,
    resendDialog: false,
    slipDialog: false,
    creditCardDialog: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    lastTabText: "Void",
    columns: standardOrderCols,
    data: [],
    allData: [],
    //filteredData: [],
    offsetTop: 0,
    stats: null,
    ord_type: ["buy", "upg", "free"],
    loading: true,
    viewIndex: 0,
    log: null,
    lagacy_query: null,
    routeTitle: "",
    selectedOrder: null,
    extendedDeadline: "",
    selectedMedia: {
      url: null,
      caption: ""
    },
    selectedError: null,
    isSuperAdmin: false,
    showExport: false,
    event: null,
    productListDialog: false,
    selectedProductData: ""
  }),
  computed: {
    ...mapState({
      selectedView: state => {
        return state.Order.view;
      },
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      },
      userInfo: state => {
        return state.Auth.user.info;
      }
    })
  },
  beforeMount() {
    //this.$router.replace({ query: { s: this.s, e: this.e } });
  },
  mounted() {
    window.addEventListener("keydown", e => {
      if (
        this.remarkDialog == false &&
        this.extendDialog == false &&
        this.resendDialog == false
      ) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  created() {
    setTimeout(() => {
      this.setView(this.selectedView, true);
      Service.Event.get(this.$route.query.e)
        .then(res => {
          if (res.success) {
            this.event = res.data.event;
            if (res.data.event.freeevent) {
              this.columns = freeOrderCols;
            }
            let data = {
              merchant_id: res.data.event.merchant_id,
              biz: "ev",
              x: res.data.event.event_id,
              e: this.$route.query.e
            };
            Service.Order.summary(data).then(r => {
              this.stats = r.data;
            });
          }
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    }, 500);
  },
  watch: {
    currentPage: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
        }
      }
    },
    search: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
          this.checkSearchStr(val);
        }
      }
    },
    "selectedOrder.days": function(newVal, oldVal) {
      let a = moment(this.selectedOrder.deadline_ts_utc);
      this.extendedDeadline = a.add("days", newVal);
      //to work with changes in someOtherProp
    }
  },
  methods: {
    parseFloat: parseFloat,
    filterActions(actionlist) {
      return actionlist.filter((item)=> this.isSuperAdmin || !item.is_so_admin_only)
    },
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    clearSearch() {
      console.log("testtet");
      this.search = "";
      this.debounceInput("");
      var tmp = document.getElementById("search");
      tmp.blur();
    },
    showProductList(order) {
      this.selectedProductData = order.orderdata;
      this.selectedOrder = order;
      this.productListDialog = true;
    },
    onAction(order, item, additionalData = null) {
      let callApi = false;

      if (item.action == "extend-deadline") {
        this.extendDialog = true;
        this.selectedOrder = {
          order_id: order.order_id,
          deadline: order.deadline,
          deadline_ts_utc: order.deadline_ts_utc,
          days: 1
        };
        return;
      }

      if (item.action == "resend") {
        this.resendDialog = true;
        this.selectedOrder = {
          order_id: order.order_id
        };
        return;
      }

      if (item.action == "approve") {
        this.onApproveDialogOpen(order.order_id);
        return;
      }

      if (item.action == "preparing") {
        this.onOrderReceivedDialogOpen(order.order_id);
        return;
      }

      if (item.action == "packed") {
        this.onPackedDialogOpen(order.order_id);
        return;
      }

      if (item.action == "shipped") {
        this.onShippedDialogOpen(order.order_id);
        return;
      }

      if (item.action == "delivered") {
        this.onDeliveredDialogOpen(order.order_id);
      }

      if (item.action == "copy-pay-link") {
        this.$copyText("https://go.soldoutt.com/" + order.unique_id).then(
          e => {
            this.callApi = false;
          },
          e => {}
        );
      }

      if (callApi) {
        let data = {
          e: this.$route.query.e,
          order_id: order.order_id,
          action: item.action,
          remark: ""
        };

        Service.Order.action(data)
          .then(res => {
            let index = this.data.findIndex(
              x => x.order_id == res.data.order.order_id
            );
            this.data[index] = res.data.order;
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
          })
          .catch(err => {
            this.$vs.notify({
              title: "Oops!",
              text: "ERROR : " + err.error,
              color: "danger"
            });
          });
      }
    },
    onUpdateRemark(order_id, remarkText) {
      Service.Order.updateRemark({
        e: this.$route.query.e,
        order_id,
        remark: remarkText
      })
        .then(res => {
          let index = this.data.findIndex(
            x => x.order_id == res.data.order.order_id
          );
          this.data[index].remark = res.data.order.remark;
          this.remarkDialog = false;
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    },
    onUpdate(order_id, action, additionalData = null) {
      let data = {
        e: this.$route.query.e,
        order_id: order_id,
        action: action,
        ...additionalData
      };

      Service.Order.action(data)
        .then(res => {
          let index = this.data.findIndex(
            x => x.order_id == res.data.order.order_id
          );
          if (action == "remark") {
            this.data[index].remark = res.data.order.remark;
            this.remarkDialog = false;
          }
          if (action == "extend-deadline") {
            this.data[index].deadline = res.data.order.deadline;
            this.extendDialog = false;
          }
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    },
    openTicket(item) {
      this.$router.push(
        "/tickets?s=" +
          this.$route.query.s +
          "&e=" +
          this.$route.query.e +
          "&o=" +
          item.order_id
      );
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    openEditRemark(item) {
      // if (!this.isSuperAdmin) {
      //   return;
      // }
      this.selectedOrder = Object.assign({}, item);
      this.remarkDialog = true;
    },
    dataProvider(ctx, callback, perPage = 15) {
      this.isBusy = true;
      setTimeout(() => {
        let data = {
          e: this.$route.query.e,
          view: this.selectedView,
          page: this.currentPage,
          perPage: perPage
        };

        if (this.$route.query.o) {
          data.o = this.$route.query.o;
        }

        if (this.ord_type.length > 0) {
          data.tp = this.ord_type;
        }

        if (data.sortBy == "approve") {
          data.sortBy = "confirmed";
        }
        if (ctx.sortBy == "approve") {
          ctx.sortBy = "confirmed";
        }

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        Service.Lagacy.get_orders(params)
          .then(res => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows.map(row => {
              let promodata = null;
              row.promotitle = "";
              row.promonote = "";
              row.promo_type = "";
              row.pccode = "";
              row.token = "";
              row.register_link = "";
              if (row.promodata) {
                const promodatajson = JSON.parse(row.promodata);
                if (promodatajson[0]) {
                  promodata = promodatajson[0];
                  row.promotitle = promodata.promotitle;
                  row.promonote = promodata.promonote;
                  row.pccode = promodata.pccode;
                  row.token = promodata.token;
                  row.register_link = promodata.register_link;
                }
              }
              return row;
            });

            if (this.viewIndex == 2) {
              this.data = this.data.filter(x => x.rowstatus == "Pending");
            }

            if (res.data.rows.length < this.perPage) {
              this.to = res.data.total;
            }

            this.lagacy_query = res.lagacy_query;
            this.role = res.data.role;
            if (res.data.role == "so-admin") {
              this.isSuperAdmin = true;
            }
            if (res.data.role != "so-admin") {
              this.columns = this.columns.filter(x => x.adminOnly == false);
            }

            if (res.data.role != "so-admin" && res.data.role != "admin") {
              this.columns = this.columns.filter(x => x.key != "edit");
            }


            // if (res.data.role != "so-admin") {
            //   this.columns = this.columns.filter(x.adminOnly == false);
            //   console.log(this.columns);
            // }
            // else if (this.event.e == "symposium") {
            //   this.columns = pttgcTicketCols;
            // }

            this.showExport = res.data.export;

            callback(this.data);
          })
          .catch(error => {
            callback([]);
          });

        return null;
      }, 500);
    },
    setView(view = "all", refresh = false) {
      this.$store.dispatch("Order/setView", view).then(res => {
        this.lastTabText = "Void";
        if (res == "confirmed") {
          this.viewIndex = 5;
          this.lastTabText = "Confirmed";
        } else if (res == "needaction") {
          this.viewIndex = 1;
        } else if (res == "pending") {
          this.viewIndex = 2;
        } else if (res == "expired") {
          this.viewIndex = 3;
        } else if (res == "waitedlist") {
          this.viewIndex = 4;
        } else if (res == "void") {
          this.viewIndex = 5;
        } else if (res == "duplicate") {
          this.viewIndex = 6;
          this.lastTabText = "Duplicate";
        } else if (res == "trash") {
          this.lastTabText = "Trash";
          this.viewIndex = 6;
        } else if (res == "all") {
          this.viewIndex = 6;
          this.lastTabText = "All";
        } else {
          this.viewIndex = 0;
        }

        this.$router
          .replace({
            query: { ...Object.assign(this.$route.query), view: res }
          })
          .catch(err => {});

        this.search = "";
        this.filter = "";
        this.currentPage = 1;

        if (refresh) {
          this.$refs.table.refresh();
        }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onExport() {
      let rows = [];
      let days = [];
      let header = [];

      if (!this.event.freeevent) {
        header = exportStandardOrderCols.map((item, index) => {
          return { text: item.label };
        });
      } else {
        header = exportFreeOrderCols.map((item, index) => {
          return { text: item.label };
        });
      }

      if (this.filter == "") {
        this.$vs.loading();
        let data = {
          e: this.$route.query.e,
          view: this.selectedView,
          download: true
        };

        if (this.ord_type.length > 0) {
          data.tp = this.ord_type;
        }

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        Service.Lagacy.get_orders(params).then(res => {
          rows = res.data.rows.map((item, index) => {
            let error_text = "";

            let amountSuffix = "";
            if (item.discount) {
              amountSuffix = item.pc + " " + item.discount;
            }
            if (item.errordate != null) {
              item.errors.map((err, index) => {
                if (err.res_msg) {
                  error_text +=
                    index + ". " + err.res_msg + " (" + err.respCode + ") / ";
                }
                if (err.failReason) {
                  error_text +=
                    index +
                    ". " +
                    err.failReason +
                    " (" +
                    err.respCode +
                    ") / ";
                }
              });
            }

            return {
              Status: item.rowstatus,
              ID: item.order_id,
              "Pay Code": item.unique_id,
              Name: item.name.first + " " + item.name.last,
              Phone: item.phone,
              Email: item.email,
              Amount: item.amount,
              "WH Amount": item.wht_amount,
              PC: item.pc,
              Discount: item.discount * -1,
              Qty: item.quantity,
              Upload: item.upload,
              Approve: item.approve,
              Channel: item.paidby,
              Errors: error_text,
              Register: item.register_date,
              "Upload Date": item.upload_date,
              Paid: item.paid_date,
              Approved: item.confirm_date,
              Deadline: item.deadline,
              Remark: item.remark,
              Country: item.ipcountry,
              Ref: item.ref
            };
          });
          let dataExport = {};
          const dataWS = XLSX.utils.json_to_sheet(rows);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "order_report.xlsx");
          this.$vs.loading.close();
        });
      } else {
        rows = this.data.map((item, index) => {
          let error_text = "";
          if (item.errordate != null) {
            item.errors.map((err, index) => {
              if (err.res_msg) {
                error_text +=
                  index + ". " + err.res_msg + " (" + err.respCode + ") / ";
              }
              if (err.failReason) {
                error_text +=
                  index + ". " + err.failReason + " (" + err.respCode + ") / ";
              }
            });
          }

          let amountSuffix = "";
          if (item.discount) {
            amountSuffix = item.pc + " " + item.discount;
          }

          return {
            Status: item.rowstatus,
            ID: item.order_id,
            "Pay Code": item.unique_id,
            Name: item.name.first + " " + item.name.last,
            Phone: item.phone,
            Email: item.email,
            Amount: item.amount,
            "WH Amount": item.wht_amount,
            PC: item.pc,
            Discount: item.discount * -1,
            Qty: item.quantity,
            Upload: item.upload,
            Approve: item.approve,
            Channel: item.paidby,
            Errors: error_text,
            Register: item.register_date,
            "Upload Date": item.upload_date,
            Paid: item.paid_date,
            Approved: item.confirm_date,
            Deadline: item.deadline,
            Remark: item.remark,
            Country: item.ipcountry,
            Ref: item.ref
          };
        });

        let dataExport = {};
        const dataWS = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, "order_report.xlsx");
      }
    },
    onExport2() {
      let rows = [];
      let days = [];
      let header = [];

      // header = [
      //   "Status",
      //   "ID",
      //   "Pay Code",
      //   "Name",
      //   "Phone",
      //   "Email",
      //   "Excl. VAT",
      //   "VAT",
      //   "Amount",
      //   "WHT",
      //   "Net Received",
      //   "Discount",
      //   "Qty",
      //   "Upload",
      //   "Channel",
      //   "Paid",
      //   "Invoice No.",
      //   "Dated",
      //   "Company Address",
      //   "Tax ID",
      //   "Sent Date",
      //   "Remark",
      // ].map((item) => {
      //   return { text: item };
      // });

      this.$vs.loading();
      try {
        this.dataProvider(
          {},
          rows => {
            const rowsData = rows.map(item => {
              // let discount =''
              // if(item.disctype == 'percent') {
              //   discount = `${item.discvalue}%`
              // } else if(item.disctype == 'amount') {
              //   discount = `${item.discvalue } Baht`
              // }

              let paidby = item.paidby;
              if (paidby == "transfer") {
                paidby = "Bank Transfer";
              }
              if (paidby == "creditcard") {
                paidby = "Credit Card";
              }
              return {
                Status: item.rowstatus,
                ID: item.order_id,
                "Pay Code": item.unique_id,
                Name: `${item.name.first} ${item.name.last}`,
                Phone: item.phone,
                Email: item.email,
                // "Excl. VAT": "",
                // "VAT": "",
                Amount: item.amount,
                // WHT: item.wht_amount,
                // "Net Received": item.amount,
                Discount: item.discount,
                Qty: item.quantity,
                Channel: paidby,
                Register: item.register_date,
                Upload: item.upload_date,
                Paid: item.paid_date,
                Confirm: item.confirm_date,
                Deadline: item.deadline,
                // "Invoice No.": item.invoiceno,

                // "Company Address": "",
                // "Tax ID": item.tax_number,
                // "Sent Date": item.confirm_date,
                Remark: item.remark,
                Country: item.ipcountry,
                Ref: item.ref,
                Promotion: item.promotitle,
                "Promotion Note": item.promonote,
                "Promotion Type": this.capitalizeFirstLetter(item.promo_type),
                "Code/Token":
                  item.promo_type == "code" || item.promo_type == "link"
                    ? item.promo_type == "code"
                      ? item.pccode
                      : item.promo_type == "link"
                      ? item.register_link
                      : ""
                    : "",
                // row.pccode = promodata.pccode;
                //   row.token = promodata.token;
                "Invited by": item.invitedby
              };
            });
            // console.log("rowsData", rowsData);
            const dataWS = XLSX.utils.json_to_sheet(rowsData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS);
            XLSX.writeFile(wb, "order_report.xlsx");
            this.$vs.loading.close();
          },
          9999
        );
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    showSlip(data) {
      this.selectedMedia.url = data.item.upload_file_url;
      this.selectedMedia.caption =
        "Payment slip for order : " + data.item.unique_id + ".";
      this.slipDialog = true;
    },
    onOpenCreditCardDialog(item) {
      if (item.item.errors != false) {
        this.selectedError = item.item.errors;
        this.creditCardDialog = true;
      }
    },
    onApproveDialogOpen(order_id) {
      Service.Order.get(order_id).then(res => {
        this.selectedOrder = Object.assign(
          {},
          { order: res.data.order, related_orders: res.data.related_orders }
        );
        this.$bvModal.show("approve-order");
      });
    },
    onOrderReceivedDialogOpen(order_id) {
      Service.Order.get(order_id).then(res => {
        this.selectedOrder = Object.assign(
          {},
          { order: res.data.order, related_orders: res.data.related_orders }
        );
        this.$bvModal.show("order-received");
      });
    },
    onPackedDialogOpen(order_id) {
      Service.Order.get(order_id).then(res => {
        this.selectedOrder = Object.assign(
          {},
          { order: res.data.order, related_orders: res.data.related_orders }
        );
        this.$bvModal.show("packed");
      });
    },
    onShippedDialogOpen(order_id) {
      Service.Order.get(order_id).then(res => {
        this.selectedOrder = Object.assign(
          {},
          { order: res.data.order, related_orders: res.data.related_orders }
        );
        this.$bvModal.show("shipped");
      });
    },
    onDeliveredDialogOpen(order_id) {
      Service.Order.get(order_id).then(res => {
        this.selectedOrder = Object.assign(
          {},
          { order: res.data.order, related_orders: res.data.related_orders }
        );
        this.$bvModal.show("delivered");
      });
    },
    onApproveDialogClose() {
      this.selectedOrder = null;
      this.$bvModal.hide("approve-order");
      this.$refs.table.refresh();
    },
    onOrderReceivedDialogClose() {
      this.selectedOrder = null;
      this.$bvModal.hide("order-received");
      this.$refs.table.refresh();
    },
    onPackedDialogClose() {
      this.selectedOrder = null;
      this.$bvModal.hide("packed");
      this.$refs.table.refresh();
    },
    onShippedDialogClose() {
      this.selectedOrder = null;
      this.$bvModal.hide("shipped");
      this.$refs.table.refresh();
    },
    onDeliveredDialogClose() {
      this.selectedOrder = null;
      this.$bvModal.hide("delivered");
      this.$refs.table.refresh();
    },
    onEmailClicked(value) {
      this.search = value;
      this.filter = value;
      this.$refs.table.refresh();
    }
  }
};
</script>
<style>
input#search:focus {
  position: absolute;
  left: 15px;
  top: 130px;
  width: calc(100% - 30px) !important;
  height: 70px;
}

#search-cancel {
  position: fixed;
  right: -50px;
  top: 150px;
}

input#search:focus ~ #search-cancel {
  position: absolute;
  right: 40px;
  top: 150px;
  z-index: 2;
}

input#search {
  transition: all ease 0.3s;
}

.sticky {
  flex-grow: 1;
  background-color: #eee;
  position: sticky;
  position: -webkit-sticky;
  overflow: scroll;
  top: 102px;
  right: 0;
  width: 100%;
  padding: 3px 0px;
  overflow-y: auto;
  z-index: 999;
}

.vs-table--thead {
  position: sticky;
  position: -webkit-sticky;
  overflow: scroll;
  top: 102px;
  right: 0;
}

/*
.v-data-table-header {
  position: fixed !important;
  top: 103px !important;
  width: auto !important;
}

.v-data-table,
.v-data-table__wrapper {
  height: calc(100vh - 300px) !important;
  overflow: scroll;
}
*/

.feather-icon {
  display: none !important;
}

.confirmed,
.shipped,
.delivered {
  background-color: #38a169;
  color: #fff !important;
  font-weight: bolder;
}
.needaction {
  background: linear-gradient(-120deg, #ff0813 0%, #c80816 100%);
}

.pending,
.awaitingpayment,
.orderreceived,
.packed,
.paid,
.preparing {
  background-color: #337ab7;
  color: #fff !important;
}

.processing {
  background-color: #d9edf7;
  color: #337ab7 !important;
}

.trash,
.duplicate,
.expired {
  background-color: #ddd;
  color: #999 !important;
  font-weight: bolder;
}

.void {
  background-color: #ddd;
  color: #444 !important;
  font-weight: bolder;
}

.vs-button-border {
  background-color: #fff !important;
}
</style>
